import { http, type HttpOptions } from './httpClient'
import type {
  CreateWorkspaceRequest,
  PaidWorkspaceCheckoutRequest,
  PaidWorkspaceCheckoutResponse,
  Paginated,
  Workspace,
} from './types'

export interface WorkspaceListParams {
  limit?: number
  offset?: number
  name?: string
  slug?: string
  my_role?: 'owner' | 'admin' | 'editor' | 'viewer'
  ordering?: string
  expand?: string
}

export const workspaceApi = {
  list: (params: WorkspaceListParams = {}) =>
    http.get<Paginated<Workspace>>('/api/workspaces/', { query: params }),

  get: (id: number) => http.get<Workspace>(`/api/workspaces/${id}/`),

  getBySlug: (slug: string) => http.get<Workspace>(`/api/workspaces/slug/${slug}/`),

  create: (body: CreateWorkspaceRequest, opts?: HttpOptions) =>
    http.post<Workspace, CreateWorkspaceRequest>('/api/workspaces/', body, opts),

  createPaidCheckout: (body: PaidWorkspaceCheckoutRequest, opts?: HttpOptions) =>
    http.post<PaidWorkspaceCheckoutResponse, PaidWorkspaceCheckoutRequest>(
      '/api/workspaces/paid-checkout/',
      body,
      opts,
    ),

  patch: (id: number, body: { name?: string; slug?: string }) =>
    http.patch<Workspace, typeof body>(`/api/workspaces/${id}/`, body),

  delete: (id: number, opts?: HttpOptions) =>
    http.delete<void>(`/api/workspaces/${id}/`, opts),

  leave: (id: number, opts?: HttpOptions) =>
    http.post<void, Record<string, never>>(`/api/workspaces/${id}/leave/`, {}, opts),
}
